// Ebooks sold on the site. Each one gets a page at /ebooks/<slug>/ and is
// promoted on recipe and insight pages whose title or abstract matches one of
// its keywords. Kept as CommonJS so gatsby-node.js can require it.
//
// status:
//   "waitlist"  - not for sale yet; page collects email signups
//   "presale"   - buy button live at the early bird price, delivered later
//   "available" - buy button live at the full price
//   "hidden"    - no page, no promotion
const ebooks = [
  {
    slug: "christmas-bonbons",
    status: "waitlist",
    title: "Christmas Bonbons",
    subtitle: "6 festive chocolates to make, box and give",
    launch: "mid-November",
    presaleDelivery: "by 30 November",
    currency: "AUD",
    price: 19,
    earlyBirdPrice: 14,
    // Hosted checkout link (Lemon Squeezy / Payhip product URL).
    checkoutUrl: null,
    // Extra fields sent to Mailchimp with waitlist signups so they can be
    // segmented, e.g. { tags: "<tag id>" } or { SIGNUP: "christmas-bonbons" }
    // once the matching tag or merge field exists in the audience.
    mailchimpFields: {},
    // Paths relative to src/images.
    heroImage: "ebooks/christmas-bonbons/hero.jpg",
    keywords: [
      "bonbon",
      "bon bon",
      "praline",
      "ganache",
      "truffle",
      "gianduja",
      "chocolate",
      "tempering",
      "christmas",
    ],
    pitch: [
      "Six brand new bonbons for the festive season, from a black sesame dome in a gold chocolate shell to Malt-O-Milk cookie rochers. None of them are published on the site.",
      "Each recipe is written the way Dessertisans recipes always are: exact weights, the reasoning behind each step, and what to do when something goes wrong. Together they make a full gift box, and every one uses a different technique.",
    ],
    bonbons: [
      {
        name: "Black Sesame Gianduja",
        description:
          "Black sesame and white chocolate gianduja moulded in a gold chocolate shell, topped with black sesame.",
        image: "ebooks/christmas-bonbons/black-sesame-gianduja.jpg",
      },
      {
        name: "Cookie Man Rochers",
        description:
          "Milk chocolate and hazelnut praline packed with Malt-O-Milk biscuits and meringue, finished with sea salt.",
        image: "ebooks/christmas-bonbons/cookie-man-rochers.jpg",
      },
      {
        name: "Hazelnut Gianduja",
        description:
          "White chocolate hazelnut gianduja enrobed in milk chocolate and decorated with an acetate transfer.",
        image: "ebooks/christmas-bonbons/hazelnut-gianduja.jpg",
      },
      {
        name: "Pistachio Gianduja",
        description:
          "Made with home-blanched pistachio paste for the greenest colour, topped with roasted pistachios.",
        image: "ebooks/christmas-bonbons/pistachio-gianduja.jpg",
      },
      {
        name: "Ube Gianduja",
        description:
          "Dehydrated purple yam folded through white chocolate, cut and served naked.",
        image: "ebooks/christmas-bonbons/ube-gianduja.jpg",
      },
      {
        name: "Aerated Milk Chocolate",
        description:
          "Milk chocolate whipped through a cream siphon and set into light, bubbly cubes.",
        image: "ebooks/christmas-bonbons/aerated-milk-chocolate.jpg",
      },
    ],
    highlights: [
      "6 exclusive Christmas bonbon recipes, each with a different technique",
      "Moulding, enrobing, acetate transfers, rochers, slabbing and aerating",
      "Step-by-step photos, including making pistachio paste and ube powder from scratch",
      "Gift boxing, storage and a make-ahead plan for a full box",
    ],
    contents: [
      "Equipment and ingredients",
      "Gianduja: the ratios behind a filling that sets",
      "Black Sesame Gianduja",
      "Cookie Man Rochers",
      "Hazelnut Gianduja",
      "Pistachio Gianduja",
      "Ube Gianduja",
      "Aerated Milk Chocolate",
      "Boxing, storing and gifting",
      "Make-ahead plan",
    ],
    faq: [
      {
        question: "What format is the ebook?",
        answer:
          "A PDF designed to read well on a tablet or phone and to print cleanly for the kitchen.",
      },
      {
        question: "Are these recipes on the website?",
        answer:
          "No. All 6 bonbon recipes are new and exclusive to the ebook.",
      },
      {
        question: "Do I need special equipment?",
        answer:
          "A digital scale, a thermometer, a polycarbonate mould and a cream siphon. The equipment chapter covers what is worth buying and what you can do without.",
      },
      {
        question: "What does joining the waitlist do?",
        answer:
          "You'll get an email when the book launches, with an early bird price for the first 48 hours. No spam, and you can unsubscribe at any time.",
      },
    ],
  },
]

module.exports = ebooks
